import useAppEvents from 'hooks/app-events/useAppEvents';

const EventHandler = () => {
    useAppEvents({ enabled: true });

    return null;
};

export default EventHandler;
